export class ProductVariationTypes {
  constructor(
    public ID: number,
    public Name: string
  ) { }
}
